import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
import { Layout, Container, PageTitle, Content } from 'src/components/Layout'
import { GoogleMapContainer } from 'src/components/Maps/KioskGoogleMap'
import { isFeatureUsed } from 'src/utils/features'
import { logError } from 'src/utils/helpers'
import intlMessages from '../translations'
import styles from './ServicesMap.module.less'

class ServicesMap extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  componentDidMount() {
    const { history, features } = this.props

    // Redirect home if this feature is not enabled
    if (!isFeatureUsed('services', features)) {
      history.push('/')
    }

    if (!(this.getUrlParam('mapFilterValue') && this.getUrlParam('mapFilterType'))) {
      // If there is no search query in URL - redirect to the list
      history.push('/services')
    }
  }

  getUrlParam = param => {
    try {
      const { match } = this.props
      return match.params[param] || null
    } catch (e) {
      logError('Get service map URL param', e)
      return null
    }
  }

  render() {
    const {
      intl,
      features,
      isWidgetState,
      history,
      notificationHeight,
      isNotificationHidden,
      countryIsoCode,
    } = this.props

    const foundedFeature = features.find(f => f.id == 'services')
    const subtitle =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.servicesHeader)

    // TODO: Later maybe add proper translation for "Petrol Stations", this is ok for now.
    const isUk = countryIsoCode && countryIsoCode.toLowerCase() === 'gb'
    const gasStationText = isUk
      ? 'Petrol Stations'
      : intl.formatMessage(intlMessages.servicesListGasStations)

    const path = history.location.pathname
    let title = ''
    let icon = ['far', 'gas-pump']
    if (path.includes('station')) {
      title = gasStationText
    } else if (path.includes('locksmith')) {
      title = intl.formatMessage(intlMessages.servicesListLocksmith)
      icon = ['far', 'key']
    } else if (path.includes('truck')) {
      title = intl.formatMessage(intlMessages.servicesListTowTruckServices)
      icon = ['far', 'truck-tow']
    } else if (path.includes('police')) {
      title = intl.formatMessage(intlMessages.servicesListPolice)
      icon = ['far', 'user-police-tie']
    }

    return (
      <Layout>
        <Content>
          <PageTitle title={title} showBack={true} subtitle={subtitle} />
          <Container className={styles.container}>
            <GoogleMapContainer
              isWidget={isWidgetState}
              icon={icon}
              mapFilterValue={this.getUrlParam('mapFilterValue')}
              mapFilterType={this.getUrlParam('mapFilterType')}
              notificationHeight={notificationHeight}
              isNotificationHidden={isNotificationHidden}
            />
          </Container>
        </Content>
      </Layout>
    )
  }
}

ServicesMap.propTypes = {
  labels: PropTypes.object.isRequired,
  intl: PropTypes.object,
  router: PropTypes.object,
}

export default withRouter(injectIntl(ServicesMap))
